/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { IGetHoldersLisProps, InviteUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "HoldersListPageService";
const log: any = LoggerModule.getInstance();

export class HoldersListPageService {
  private static instance: HoldersListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private coreRestAPI: string;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.coreRestAPI = props?.coreRestAPI ?? props?.loginRestAPI;
  }

  public static getInstance(props: any = {}): HoldersListPageService {
    if (!HoldersListPageService.instance) {
      HoldersListPageService.instance = new HoldersListPageService(props);
    }
    return HoldersListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: IGetHoldersLisProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //HoldersList Props
    compProps = await agent.getHoldersListProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //HolderGroups props
    compProps = await agent.getHolderGroupsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getHolderGroups(args: any = {}) {
    const agent = getAgent();
    const content = await agent.getHolderGroupsProps(args);
    return content?.studentGroup || [];
  }

  public async inviteUser(args: InviteUserProps) {
    log.info(`invite user`, args);
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
    };
    const agent = getAgent();
    return agent.getInviteUser(_args);
  }

  public async getNextHolderId(groupId: string) {
    const agent = getAgent();
    return agent.getNextHolderId({ groupId, apiURL: this.loginRestAPI });
  }

  public async deleteUser(args: any) {
    log.info(`delete  user service`, args);
    const agent = getAgent();
    return agent.getDeleteUser(args);
  }

  public async suspendUser(args: any) {
    log.info(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }
}
